import React, { useEffect, useMemo, useState, } from 'react';
import { Dimensions, Image, Platform, ScrollView, StyleSheet, TouchableOpacity, View, } from 'react-native';
import { addCommasToNumber, convertEpochToDateWithoutYear } from '../utils';
import { ButtonSizeDLS, ButtonTypeDLS, ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, IconSizeTokens, IconTokens, TextAlignTokens, TypographyTypeDLS, } from '@voltmoney/schema';
import ThemeProvider from '@voltmoney/theme';
import { ModalAlignmentEnum, SCREEN_SIZE, } from '@voltmoney/types';
import BottomSheet from '../BottomSheet';
import { Typography } from '../../typography/Typography';
import { Button } from '../../button/Button';
import { isMobile } from '../../stack/utils';
import AccordionListItem from './AccordionAnimated';
import CustomHeader from '../../customHeader/CustomHeader';
import TooltipComp from '../TooltipComp';
import Icon from "../../icon/Icon";
import ButtonDLSBase from "../../button/ButtonDLS.base";
import NeedHelpDC from "../NeedHelpDC";
const OutstandingDues = ({ bankData, triggerAction, backAction, applyAction, modalState, height, loading, needHelp, excessAmountHandleAction, excessAmountLoader, contactUsDetails, isFromJupiter, showExcessAmountHandlingFlag, isLoanExpired }) => {
    const [showModal, setShowModal] = useState(false);
    const [isRunning, setIsRunning] = useState(false);
    const [cardState, setModalState] = useState('Penny');
    const [modalHeight, setModalHeight] = useState(332);
    const [isDismissable, setDismissable] = useState(false);
    const [showConfimation, setShowConfirmation] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showToolTip, setShowToolTip] = useState(false);
    const [showExcessAmountCard, setShowExcessAmountCard] = useState(false);
    const [showNeedHelp, setShowNeedHelp] = useState(false);
    //@ts-ignore
    const showExcessAmountUI = (bankData?.excessAmount > 0 || bankData?.excessAmount > 0.0) && showExcessAmountHandlingFlag;
    const theme = ThemeProvider.getTheme();
    const colorMapping = theme.colors;
    useEffect(() => {
        if (modalState) {
            if (modalState === 'error') {
                setDismissable(true);
                setModalHeight(244);
            }
            if (modalState === 'success') {
                setModalHeight(228);
            }
            setModalState(modalState);
        }
        else {
            setModalState('Penny');
        }
    }, [modalState]);
    useEffect(() => {
        if (!loading) {
            setIsLoading(false);
        }
    }, [loading]);
    const handleNeedHelp = () => {
        setShowNeedHelp(true);
    };
    const headerTitle = () => {
        let title = '';
        if (!isLoanExpired) {
            title = 'Foreclose your loan';
        }
        //@ts-ignore\
        else if (bankData?.netPayable >= 0) {
            title = 'Pay outstanding dues';
        }
        else
            title = 'Get refund';
        return title;
    };
    const _headerChild = useMemo(() => {
        return (React.createElement(CustomHeader, { goBackId: 'bt_outstanding_goBack', needHelpId: 'bt_outstanding_needHelp', 
            //@ts-ignore
            title: headerTitle(), needHelpAction: handleNeedHelp, goBackAction: backAction, hideNeedHelp: false, showNeedHelpNewArch: true, triggerAction: triggerAction }));
    }, []);
    const modalContentPresenter = () => {
        return null;
    };
    const handleStartStop = () => {
        setIsRunning((prevIsRunning) => !prevIsRunning);
    };
    const convertEpochToDate = (timeStamp) => {
        const date = new Date(timeStamp);
        // Define an array of month names
        const monthNames = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December',
        ];
        // Extract the day, month, and year from the date
        const day = date.getDate();
        const month = monthNames[date.getMonth()];
        const year = date.getFullYear();
        // Create the formatted date string
        const formattedDate = `${day} ${month}, ${year}`;
        return formattedDate;
    };
    const _bodyChild = () => {
        return (React.createElement(View, { style: {} },
            React.createElement(View, { style: { backgroundColor: colorMapping[ColorTokens.Primary_05], padding: 16 } },
                React.createElement(View, { style: {
                        padding: 20,
                        borderRadius: 12,
                        borderWidth: 1,
                        backgroundColor: 'white',
                        borderColor: '#E7EBFA',
                        flexDirection: 'row',
                        alignItems: 'center'
                    } },
                    React.createElement(Image, { source: { uri: 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/outstanding_icon.png' }, style: { width: 56, height: 56 } }),
                    React.createElement(View, { style: { marginLeft: 12 } },
                        React.createElement(Typography, { label: showExcessAmountUI ? 'You have excess amount' : 'You have outstanding dues', fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography, { label: showExcessAmountUI ? "Place refund request to proceed" : "Please clear your dues to proceed", fontWeight: '500', fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }))),
                React.createElement(View, { style: { marginTop: 24, paddingBottom: -4 } },
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: "Net dues payable", fontWeight: '700', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Poppins }))),
            React.createElement(View, null,
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16, marginRight: 18 } },
                    React.createElement(Typography, { label: 'Outstanding principal', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(bankData.outstandingPrincipal), fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(AccordionListItem, { id: 'acd_outstanding_outstandingInterest', title: 'Outstanding interest', subTitle: `₹${addCommasToNumber(calculateTotalOutstandingInterest())}` },
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 16, marginRight: 18 } },
                        React.createElement(Typography, { label: 'Outstanding Interest', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `₹${addCommasToNumber(bankData.outstandingInterest)}`, fontWeight: '500', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16,
                            paddingLeft: -16,
                            marginRight: 18
                        } },
                        React.createElement(Typography, { label: 'Interest accrued not due', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹' + addCommasToNumber(bankData.interestAccruedNotDue), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16,
                            paddingLeft: -16,
                            marginRight: 18
                        } },
                        React.createElement(Typography, { label: 'Penal interest accrued not due', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹' + addCommasToNumber(bankData.penalInterestAccruedNotDue), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                    bankData?.penalInterest && bankData?.penalInterest !== 0 && bankData?.penalInterest !== 0.00 ?
                        React.createElement(View, { style: {
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                paddingVertical: 16,
                                paddingLeft: -16,
                                marginRight: 18
                            } },
                            React.createElement(Typography, { label: 'Penal interest', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(Typography
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                label: `₹${addCommasToNumber(bankData?.penalInterest)}`, fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))
                        : React.createElement(React.Fragment, null),
                    // @ts-ignore
                    bankData?.nextDayInterestChargeDue && React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16,
                            paddingLeft: -16,
                            marginRight: 18
                        } },
                        React.createElement(View, { style: {
                                flexDirection: 'row'
                            } },
                            React.createElement(Typography
                            // @ts-ignore
                            , { 
                                // @ts-ignore
                                label: `Interest for ${convertEpochToDateWithoutYear(bankData?.nextDayInterestDate)}`, fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                            React.createElement(TouchableOpacity, { style: { marginTop: 3, marginLeft: 2 }, onPress: () => {
                                    // Logic to show the tooltip for next day interest
                                    setShowToolTip(!showToolTip);
                                } },
                                React.createElement(Icon, { name: IconTokens.Info, size: IconSizeTokens.MD, color: ColorTokens.Grey_Charcoal }),
                                showToolTip &&
                                    React.createElement(TooltipComp, { title: "Payment made post 6 PM is accounted on next day. Hence net payable includes today interest on outstanding amount and any accruing penal charges.", leftShiftContent: -135, fontSize: FontSizeTokens.XS, textColor: ColorTokens.Grey_Night }))),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹' + addCommasToNumber(bankData?.nextDayInterestChargeDue), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                React.createElement(AccordionListItem, { id: 'acd_outstanding_outstandingCharges', title: 'Outstanding charges', subTitle: `₹${addCommasToNumber(calculateTotalOutstandingCharged())}`, showTopDivider: false },
                    React.createElement(View, { style: {
                            flexDirection: 'row',
                            justifyContent: 'space-between',
                            paddingVertical: 16,
                            paddingLeft: -16,
                            marginRight: 18
                        } },
                        React.createElement(Typography, { label: 'Outstanding charges', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹' + addCommasToNumber(bankData.outstandingCharges), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', paddingVertical: 16, marginRight: 18 } },
                        React.createElement(Typography, { label: 'Total Demat and bounce charged', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: '₹ ' + addCommasToNumber(bankData.totalNotionalChargesAndDematBounce), fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
                bankData.penalInterestReceivable && bankData.penalInterestReceivable !== "0" &&
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16 } },
                        React.createElement(Typography, { label: 'Penal interest receivable', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `-₹ ${addCommasToNumber(bankData.penalInterestReceivable)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
                bankData.excessMargin !== 0.00 &&
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16, marginRight: 18 } },
                        React.createElement(Typography, { label: 'Excess margin', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `-₹${addCommasToNumber(bankData.excessMargin)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
                bankData.advanceInterest !== 0.00 &&
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16, marginRight: 18 } },
                        React.createElement(Typography, { label: 'Advance interest', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `-₹${addCommasToNumber(bankData.advanceInterest)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
                bankData.tdsreceivable && bankData.tdsreceivable !== "0" &&
                    React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16 } },
                        React.createElement(Typography, { label: 'TDS receivable', fontWeight: '400', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                        React.createElement(Typography
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            label: `-₹ ${addCommasToNumber(bankData.tdsreceivable)}`, fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Secondary_100, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: { flexDirection: 'row', justifyContent: 'space-between', padding: 16, marginRight: 18 } },
                    React.createElement(Typography, { label: 'Net dues', fontWeight: '600', fontSize: FontSizeTokens.SM, lineHeight: 20, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(bankData.netPayable), fontWeight: '600', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter }))),
            React.createElement(View, { style: {
                    height: 100
                } })));
    };
    const calculateTotalOutstandingInterest = () => {
        // @ts-ignore
        const total = (bankData.penalInterestAccruedNotDue || 0) + (bankData.outstandingInterest || 0) + (bankData.interestAccruedNotDue || 0) + (bankData?.nextDayInterestChargeDue || 0) + (bankData.penalInterest || 0);
        return Math.ceil(total * 100) / 100;
    };
    const calculateTotalOutstandingCharged = () => {
        // @ts-ignore
        let creditData = bankData;
        // @ts-ignore
        return creditData.outstandingCharges || 0 + creditData.totalNotionalChargesAndDematBounce || 0;
    };
    const calculateTotalOutstandinCharges = () => {
        // @ts-ignore
        let creditData = bankData;
        // @ts-ignore
        return creditData.outstandingCharges || 0 + creditData.outstandingInterest || 0 + creditData.interestAccruedNotDue || 0;
    };
    const _footerChild = () => {
        return (React.createElement(View, { style: {
                position: 'absolute',
                bottom: 0,
                width: '100%',
                justifyContent: 'center',
                borderColor: '#F2F4F7',
                borderTopWidth: 0.5,
                paddingHorizontal: -16,
                paddingVertical: 8,
                shadowOpacity: 0.08,
                elevation: 10,
                backgroundColor: 'white',
                shadowOffset: {
                    width: 0,
                    height: -1,
                },
                shadowRadius: 5,
            } },
            React.createElement(View, { style: { marginHorizontal: 16, flexDirection: 'row', justifyContent: "space-between", paddingVertical: 16 } },
                React.createElement(View, null,
                    React.createElement(Typography, { label: 'Net dues', fontWeight: '400', fontSize: FontSizeTokens.XS, lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontFamily: FontFamilyTokens.Inter }),
                    React.createElement(Typography
                    // @ts-ignore
                    , { 
                        // @ts-ignore
                        label: '₹' + addCommasToNumber(bankData.netPayable), fontWeight: '700', fontSize: FontSizeTokens.MD, lineHeight: 24, color: ColorTokens.Grey_Night, fontFamily: FontFamilyTokens.Inter })),
                React.createElement(View, { style: { width: '55%' } },
                    React.createElement(Button, { id: 'bt_outstanding_payDues', type: ButtonTypeTokens.LargeFilled, onPress: () => {
                            if (!isLoading) {
                                if (showExcessAmountUI) {
                                    setShowExcessAmountCard(true);
                                }
                                else if (applyAction) {
                                    setIsLoading(true);
                                    handleStartStop();
                                    triggerAction(applyAction);
                                }
                            }
                        }, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, loading: isLoading, label: showExcessAmountUI ? "Get refund" : "Pay dues", width: ButtonWidthTypeToken.FULL })))));
    };
    const renderExcessAmountCard = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, onPress: () => {
            }, style: {
                alignContent: 'center',
                alignItems: 'center',
                paddingTop: 24,
                paddingBottom: 16,
                paddingHorizontal: 16,
                flex: 1
            } },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_INFO_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.Grey_Smoke }),
            React.createElement(View, { style: {
                    marginTop: 24,
                    borderRadius: 8,
                    padding: 12,
                    backgroundColor: '#F1F3F5',
                    alignItems: 'center',
                    alignContent: 'center',
                    justifyContent: 'center',
                    marginBottom: 24
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: "Foreclosure request will be automatically initiated once the refund is successful.", textAlign: TextAlignTokens.center, color: ColorTokens.Grey_Charcoal })),
            React.createElement(ButtonDLSBase, { sizeDLS: ButtonSizeDLS.MEDIUM, typeDLS: ButtonTypeDLS.PRIMARY, label: isLoanExpired ? 'Refund & close loan' : 'Refund & foreclose', onPress: async () => {
                    await triggerAction({
                        ...excessAmountHandleAction,
                        payload: {
                            //@ts-ignore
                            excessAmount: bankData.excessAmount
                        }
                    });
                }, isDisabled: false, loading: excessAmountLoader }),
            React.createElement(View, { style: { marginTop: 12, width: '100%' } },
                React.createElement(Button, { typeDLS: ButtonTypeDLS.SECONDARY, label: "Contact support", width: ButtonWidthTypeToken.FULL, onPress: () => { setShowNeedHelp(true); } }))));
    };
    const renderMainBody = () => {
        return (React.createElement(TouchableOpacity, { style: [styles.container, { height: Platform.OS === "ios" ? height - 15 : height }], activeOpacity: 1, onPress: () => setShowToolTip(false) },
            React.createElement(View, { style: {
                    flex: 1,
                } },
                React.createElement(View, null, _headerChild),
                React.createElement(ScrollView, { style: [{ height: height - 420, paddingBottom: 100 }] }, _bodyChild()),
                React.createElement(View, { style: styles.footer }, !showExcessAmountCard && _footerChild())),
            showModal && (React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: true, height: 300, width: '100%', closeFunction: () => setShowModal(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').height - 70
                        : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, modalContentPresenter()))),
            showExcessAmountCard && (React.createElement(View, { style: {
                    position: 'absolute',
                    bottom: 0
                } },
                React.createElement(BottomSheet, { autoAdjustHeight: true, height: 300, width: '100%', closeFunction: () => setShowExcessAmountCard(false), alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').height
                        : height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width))
                        ? Dimensions.get('window').width
                        : 504, routeId: 'routeId', handleKeyboard: true }, renderExcessAmountCard()))),
            showNeedHelp && React.createElement(NeedHelpDC, { showNeedHelp: showNeedHelp, setShowNeedHelp: setShowNeedHelp, contactUsDetails: contactUsDetails, isFromJupiter: isFromJupiter })));
    };
    return renderMainBody();
};
export const getScreenType = (screenWidth) => {
    const screenWidthX = screenWidth || Dimensions.get('window').width;
    if (screenWidthX < 576)
        return SCREEN_SIZE.X_SMALL;
    if (screenWidthX < 768)
        return SCREEN_SIZE.SMALL;
    if (screenWidthX < 992)
        return SCREEN_SIZE.MEDIUM;
    if (screenWidthX < 1200)
        return SCREEN_SIZE.LARGE;
    if (screenWidthX >= 1200)
        return SCREEN_SIZE.X_LARGE;
    return SCREEN_SIZE.X_SMALL;
};
const styles = StyleSheet.create({
    container: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        marginHorizontal: -16,
    },
    blankContainer: {
        height: isMobile(getScreenType(Dimensions.get('window').width))
            ? Dimensions.get('window').height - 70
            : Dimensions.get('window').height - 114,
        width: '100%',
    },
    backdrop: {
        flex: 1,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        justifyContent: 'center',
        alignItems: 'center',
    },
    backdropText: {
        color: 'white',
        fontSize: 16,
    },
    contentContainer: {
        padding: 16,
        flex: 1, // pushes the footer to the end of the screen
    },
    card: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: 'white',
        height: '50%',
        padding: 20,
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
    },
    cardText: {
        fontSize: 18,
    },
    groupContainer: {
        zIndex: 0,
    },
    groupLayout: {
        height: 88,
        width: '100%',
        borderRadius: 16,
    },
    boldText: {
        fontWeight: 'bold',
        color: '#1D2939',
        fontSize: 14,
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        zIndex: 99,
        width: '100%',
        borderWidth: 1,
        borderColor: '#F1F3F5',
        backgroundColor: 'rgb(255, 255, 255)',
        shadowColor: 'rgba(0, 0, 0, 0.2)',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowOpacity: 0.5,
    },
    frameGroup: {
        borderRadius: 8,
        shadowColor: 'rgba(0, 0, 0, 0.1)',
        shadowRadius: 8,
        elevation: 8,
        borderColor: '#e4e7ec',
        paddingBottom: 61,
        marginTop: 16,
        borderStyle: 'solid',
        shadowOpacity: 1,
        shadowOffset: {
            width: 0,
            height: 2,
        },
    },
    circle: {
        width: 24,
        height: 24,
        borderRadius: 24 / 2,
        backgroundColor: '#98A2B3',
        justifyContent: 'center',
        alignItems: 'center',
    },
    text: {
        fontSize: 32,
        lineHeight: 40,
        textShadowColor: 'rgba(8, 127, 58, 0.12)',
        textShadowOffset: {
            width: 2,
            height: 2,
        },
        textShadowRadius: 0,
    },
    tooltip: {
        position: 'absolute',
        backgroundColor: '#667085',
        color: 'white',
        padding: 16,
        borderRadius: 5,
        width: 272,
        bottom: '100%',
        left: '50%',
        transform: [{ translateX: -150 }],
    },
    text2Typo: {
        fontWeight: '700',
        color: '#00682C',
    },
    frameLayout: {
        borderWidth: 1,
        alignSelf: 'stretch',
    },
    vectorGroupFlexBox: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    groupChildLayout1: {
        height: 24,
        width: 24,
        left: 0,
        position: 'absolute',
    },
    groupChildLayout: {
        height: 11,
        width: 66,
        top: 3,
        position: 'absolute',
    },
    groupChild4ShadowBox: {
        shadowOpacity: 1,
        elevation: 6,
        shadowRadius: 6,
        shadowOffset: {
            width: 0,
            height: 1,
        },
        position: 'absolute',
    },
    text1Typo: {
        fontWeight: '700',
        color: '#00682C',
    },
});
export default OutstandingDues;
